import { HTTP } from "@/axios.js"
import store from '@/store.js'
export default {
    reportList: (month) => {
        return HTTP.get('/orderwebpage/report?m='+month, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
}